import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, DatePicker, Form, notification} from 'antd';

import {confirmPurchaseOrder, getPurchaseOrder} from './actions';
import InputContact from "../common/InputContact";
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class ConfirmPurchaseOrderForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.purchaseId !== this.props.match.params.purchaseId) {
      this._load();
    }
  }

  _load = () => {
    const {purchaseId} = decodeParams(this.props.match.params);
    this.props.getPurchaseOrder({purchaseId});
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {purchaseId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.confirmPurchaseOrder({...values, purchaseId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, purchaseOrder} = this.props;
    return (
      <Card title="Confirm Purchase Order">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Purchase Order"
          >
            {`${purchaseOrder.supplierName} - ${purchaseOrder.status} (${purchaseOrder.modifiedAt})`}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Confirmed Date"
          >
            {getFieldDecorator('confirmedDate', {
              rules: [
                { required: true, message: 'Please input your Confirmed Date' },
              ]
            })(
              <DatePicker />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Confirmed By"
          >
            {getFieldDecorator('confirmedBy', {
              initialValue: null,
            })(
              <InputContact key={`confirm-${purchaseOrder.purchaseId}`}/>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Expected Delivery Date"
          >
            {getFieldDecorator('expectedDeliveryDate', {initialValue: null})(
              <DatePicker />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Confirm Purchase Order
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

ConfirmPurchaseOrderForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  dispensaryId: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  confirmPurchaseOrder: PropTypes.func.isRequired,
  getPurchaseOrder: PropTypes.func.isRequired,
  purchaseOrder: PropTypes.object.isRequired,
};

const ConfirmPurchaseOrderPage = Form.create()(ConfirmPurchaseOrderForm);

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  loading: state.purchaseOrder.purchaseOrderLoading || state.purchaseOrder.confirmPurchaseOrderLoading,
  purchaseOrder: state.purchaseOrder.purchaseOrder || {},
});

const mapDispatchToProps = dispatch => ({
  confirmPurchaseOrder: payload => (dispatch(confirmPurchaseOrder(payload))),
  getPurchaseOrder: payload => (dispatch(getPurchaseOrder(payload))),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmPurchaseOrderPage);


// WEBPACK FOOTER //
// ./src/PurchaseOrder/ConfirmPurchaseOrderPage.js